export default __webpack_public_path__ + "static/media/gejala.58d3c4c5.png";